export default {"src":"/_next/static/media/tag-classic.9f310128.svg","height":20,"width":26,"blurWidth":0,"blurHeight":0};